import React from 'react'
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom'
import Link, { LinkProps as MuiLinkProps } from '@mui/material/Link'

type MuiRouterLinkProps = Omit<MuiLinkProps, 'component'> & RouterLinkProps;

export const MuiRouterLink = React.forwardRef<HTMLAnchorElement, MuiRouterLinkProps>((props, ref) => {
  return <Link component={RouterLink} ref={ref} {...props} />
});
